import { render, staticRenderFns } from "./nshop-order-view.vue?vue&type=template&id=f16c3bdc&scoped=true&"
import script from "./nshop-order-view.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view.vue?vue&type=style&index=0&id=f16c3bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16c3bdc",
  null
  
)

export default component.exports